@if (isBrowser) {
    <iframe
      #adFrame
      [src]="safeUrl"
      [style.height.px]="iframeHeight()"
      [style.opacity]="visible() ? 1 : 0"
      (load)="onFrameLoad($event)"
      class="transition-opacity duration-200"
      width="100%"
      frameborder="0"
      scrolling="no"
      style="display:block;"
    ></iframe>
  } @else {
    <!-- Reserve the default height during SSR so the page doesn't jump when the iframe mounts -->
    <div [style.height.px]="iframeHeight()"></div>
  }